export default "__VITE_ASSET__8a316bc5__"